import React from 'react';
import { DialogBox } from '../../../msreact-kit/packages/html-components';

import './index.scss';
import i18next from 'i18next';

const PreviewModal = ({ mediaUrl, isVideo, handlePreviewModal }) => {
  return (
    <div className='preview-modal'>
      <DialogBox
        title=' '
        handleCancel={handlePreviewModal}
        isPrimaryBtn={false}
        isDivider={true}
        cssName='preview-modal'
      >
        <div className='m-dialog__content'>
          {!isVideo ? (
            <img src={mediaUrl} alt='' className='preview-modal__img' />
          ) : (
            <video controls autoPlay className='preview-modal__video'>
              <source src={mediaUrl} type='video/mp4' />
              <track
                kind='captions'
                src=''
                label={i18next.t('SHARED.NO_CAPTIONS')}
              />
            </video>
          )}
        </div>
      </DialogBox>
    </div>
  );
};

export default PreviewModal;
